module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/955fc0224762c96ebcc86065fa9f14f0.gif";